module.exports = __webpack_public_path__ + "static/media/telescope.3c54f070.svg";